import { combineEpics } from 'redux-observable';

import builds from './builds/epics';
import { fetchAllProjects, pollTasksEpic } from './projects/epics';

const rootEpic = combineEpics(
  builds,
  pollTasksEpic,
  fetchAllProjects,
);

export default rootEpic;
